// Utils
import { stringify } from "qs";
import { useQueryString } from "src/design-system/core/hooks";
import type { Id } from "src/types/id";
import type { ThirdServiceCategory } from "src/types/posCredential";

export const PATH_ORGANIZATION = "/app/organization";
export const ORGANIZATION_TABLES_VIEW_QS_KEY = "partners-tools-table";
export const ORGANIZATION_SERVICE_VIEW_QS_KEY = "service";
export const ORGANIZATION_BILLING_POS_QS_KEY = "pos-id";

export enum OrganizationTabs {
    Billing = "billing",
    Details = "details",
    ExternalTools = "external-pos",
    Poss = "poss",
    Invoices = "invoices",
}

export enum OrganizationToolsTabsEnum {
    ExternalPos = "external-pos",
    SalesChannel = "sales-channel",
}

export const organizationRoutes = {
    billingView: ({ posId }: { posId?: Id } = {}): string =>
        `${PATH_ORGANIZATION}/${OrganizationTabs.Billing}${stringify(
            { [ORGANIZATION_BILLING_POS_QS_KEY]: posId },
            { addQueryPrefix: true }
        )}`,
    invoicesListView: (): string => `${PATH_ORGANIZATION}/${OrganizationTabs.Invoices}`,
    detailsView: (): string => `${PATH_ORGANIZATION}/${OrganizationTabs.Details}`,
    externalToolsView: (
        params: { tab?: OrganizationToolsTabsEnum; service?: ThirdServiceCategory } = {}
    ): string =>
        `${PATH_ORGANIZATION}/${OrganizationTabs.ExternalTools}${stringify(
            {
                [ORGANIZATION_TABLES_VIEW_QS_KEY]: params.tab,
                [ORGANIZATION_SERVICE_VIEW_QS_KEY]: params.service,
            },
            { addQueryPrefix: true }
        )}`,
    possView: (): string => `${PATH_ORGANIZATION}/${OrganizationTabs.Poss}`,
};

export function useOrganizationBillingViewPosId(): {
    posId: Id;
    setPosId: (posId: Id) => void;
} {
    const [posId, setPosId] = useQueryString(ORGANIZATION_BILLING_POS_QS_KEY);

    return {
        posId: posId ? parseInt(posId.toString(), 10) : undefined,
        setPosId: (posId: Id) => setPosId(posId?.toString()),
    };
}

export function useOrganizationTableViewTabs(): {
    organizationTableTab: OrganizationToolsTabsEnum;
    setOrganizationTableTab: (organizationTableTab: OrganizationToolsTabsEnum) => void;
} {
    const [organizationTableTab, setOrganizationTableTab] = useQueryString(
        ORGANIZATION_TABLES_VIEW_QS_KEY,
        OrganizationToolsTabsEnum.ExternalPos
    );

    return {
        organizationTableTab: organizationTableTab ?? OrganizationToolsTabsEnum.ExternalPos,
        setOrganizationTableTab,
    };
}
